import MetaDescriptionGenerator from '../../../src/components/content-ai-tools/MetaDescriptionGenerator';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={MetaDescriptionGenerator} />;
};

export default PublicDiscoveryKeywordsWrapped;
